import { useEffect } from "react";
import { useState } from "react"

export default function CountdownTimer({ onComplete, timeFormatter, startFrom }) {
    const [time, setTime] = useState(startFrom);
    let timer;
    function updateTime() {
        timer = setInterval(() => {
            if (time > 0) {
                setTime((pre) => {
                    return pre - 1;
                })
            } else {
                clearInterval(timer);
                onComplete();
            }
        }, 1000);
    }
    useEffect(() => {
        updateTime();
    }, []);
    useEffect(() => {
        // console.log('time: ', time);
        if (time <= 0) {
            clearInterval(timer);
            onComplete(time);
        }

    }, [time])



    return (
        <>
            {timeFormatter(time)}
        </>)

}